import { ODataStoreRequestConfiguration } from '@/auth/api/config'
import { useTokenRefresh } from '@/auth/azure/azureManager'
import DateColumn from '@/components/date-column/DateColumn'
import { ObjectCodeLink } from '@/components/object-code-link/ObjectCodeLink'
import { evento_dump } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { DumpEditorEventsGridProps } from '@/routes/dumps/DumpEditor.types'
import { useScreenSize } from '@/themes/media-query'
import {
  Column,
  DataGrid,
  StateStoring,
  HeaderFilter,
  FilterPanel,
  FilterRow,
  Toolbar,
  Item,
  DataGridRef,
  DataGridTypes,
} from 'devextreme-react/data-grid'
import DataSource from 'devextreme/data/data_source'
import ODataStore from 'devextreme/data/odata/store'
import { ClickEvent } from 'devextreme/ui/button'
import notify from 'devextreme/ui/notify'
import { memo, useRef } from 'react'

const DumpEditorEventsGrid = (props: DumpEditorEventsGridProps) => {
  const { dump } = props
  const currentScreenSize = useScreenSize()

  const token = useTokenRefresh()
  const gridRef = useRef<DataGridRef>(null)

  const dumpEventsDataSource = new DataSource({
    store: new ODataStore({
      url: `${import.meta.env.VITE_QSADMINAPI_HOST}/evento_dump`,
      key: 'id',
      version: 4,
      errorHandler: (e) => {
        console.error(e.errorDetails)
        if (!e.errorDetails) return
        notify(
          {
            message: `Errore : ${e.errorDetails?.message}`,
            type: 'error',
            displayTime: 5000,
          },
          {
            position: 'bottom center',
            direction: 'up-push',
          },
        )
      },
      beforeSend: ODataStoreRequestConfiguration(token),
      deserializeDates: false,
    }),
    filter: [['dump.id', dump?.id]],
    expand: ['utente', 'tipologia'],
  })

  return (
    <>
      <DataGrid
        id={`dump-events-grid`}
        ref={gridRef}
        dataSource={dumpEventsDataSource}
        noDataText="Nessun evento associato al dump"
        showBorders={true}
        showColumnLines={true}
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        columnHidingEnabled={currentScreenSize.isSmall || currentScreenSize.isXSmall || currentScreenSize.isMedium}
        allowColumnReordering={true}
        allowColumnResizing={true}
        rowAlternationEnabled={true}
        wordWrapEnabled={false}
        repaintChangesOnly={true}
        width="100%"
        height={290}
      >
        <StateStoring enabled={true} type="localStorage" storageKey={'dump-events-grid'} savingTimeout={50} />
        <HeaderFilter visible={true} />
        <FilterPanel visible={true} />
        <FilterRow visible={true} />
        {DateColumn({
          dataField: 'data',
          caption: 'DATA',
          width: 'auto',
          format: 'dd/MM/yyyy HH:mm:ss',
          defaultSortOrder: 'desc',
          visible: true,
          allowSorting: false,
        })}
        <Column dataField={'utente.fullname'} caption={'UTENTE'} allowSorting={false} />
        <Column dataField={'tipologia.nome'} caption={'TIPOLOGIA'} allowSorting={false} />
        <Column dataField={'note'} caption={'NOTE'} allowSorting={false} encodeHtml={false} />
        <Toolbar>
          <Item
            location="before"
            locateInMenu="never"
            showText="inMenu"
            widget="dxButton"
            options={{
              hint: 'Refresh',
              text: 'Refresh',
              icon: 'refresh',
              onClick: (e: ClickEvent) => {
                gridRef.current?.instance().refresh()
              },
              stylingMode: 'text',
            }}
          ></Item>
        </Toolbar>
      </DataGrid>
    </>
  )
}

const DumpEditorEventsGridMemoed = memo(DumpEditorEventsGrid, (oldProps, newProps) => {
  return oldProps.dump?.id === newProps.dump?.id
})

export default DumpEditorEventsGridMemoed
